import * as React from 'react';
import { ChevronDownIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

const SelectNative = ({ className, children, icon: Icon = ChevronDownIcon, ...props }) => {
  return (
    <div className="relative flex">
      <select
        data-slot="select-native"
        className={cn(
          'shadow-xs peer inline-flex w-full cursor-pointer appearance-none items-center rounded-md border border-primary-lightest bg-background text-sm text-neutral outline-none transition-colors duration-150 has-[option[disabled]:checked]:text-muted-foreground',
          'hover:border-neutral-light hover:bg-bright hover:text-neutral-dark',
          'focus-visible:border-neutral-dark focus-visible:text-neutral-dark focus-visible:outline-none',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          props.multiple ? 'py-1 *:px-3 *:py-1 [&_option:checked]:bg-accent' : 'h-10 pe-8 ps-3',
          className
        )}
        {...props}
      >
        {children}
      </select>
      {!props.multiple && (
        <span className="peer-aria-invalid:text-destructive/80 pointer-events-none absolute inset-y-0 end-0 flex h-full w-9 items-center justify-center text-muted-foreground/80 peer-disabled:opacity-50">
          <Icon
            size={16}
            aria-hidden="true"
          />
        </span>
      )}
    </div>
  );
};

export { SelectNative };
